export const testimonialsarray = [
    {
        id: 1,
        name: "Jovial atieno",
        review: "The best service I could ask for a campus student. Awesome, great follow-up services that helped me throughout the process from start to the end. Thanks to Eazistey for a great facility!"
    },
    {
        id: 2,
        name: "Victor kamau",
        review: "It was an amazing experience with Eazistey. The work they do is really appreciable. The only thing we need to do is to provide details. The people at Eazistey provide great support."
    },
    {
        id: 4,
        name: "Ann Musembi",
        review: "Experience was amazing!! I’m going to chuka university. Great prices & the rent durations are negotiable. Also as an art student I do appreciate the website design — its clear, visible & well placed."
    },
    {
        id: 5,
        name: "Walter",
        review: "Eazistey performed very professionally with great communication and excellent hostel images. They earned my confidence during my admission to chuka university"
    },
    {
        id: 3,
        name: "Henry",
        review: "I've have been very satisfied with the process that Eazistey has in place. From searching.viewing and and directions to the specific hostel.Excellent"
    }
]
